"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectsAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var ProjectsAPI = /*#__PURE__*/function () {
  function ProjectsAPI() {
    (0, _classCallCheck2["default"])(this, ProjectsAPI);
  }
  (0, _createClass2["default"])(ProjectsAPI, null, [{
    key: "findProjects",
    value: function findProjects() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'MY';
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '11D';
      var where = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '1';
      var cb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.error(j);
      };
      var params = {
        key: key,
        page: page,
        Rows: rows,
        cOrder: order,
        cWhere: where
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jProjectFinder', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getProject",
    value: function getProject(prjId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jGetProject', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveProject",
    value: function saveProject(data) {
      var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      data.clone = clone ? 1 : 0;
      var params = {
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jSaveProject', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveViewMaker",
    value: function saveViewMaker(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jSaveViewMaker', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "appendViewMakerRows",
    value: function appendViewMakerRows(data) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jAppendViewMakerRows', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteProject",
    value: function deleteProject(prjId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId
      };
      _NextApiClient.NextApiClient.comg(this.service, 'DeleteProject', params, function (txt) {
        if (txt.toUpperCase && txt.toUpperCase() === 'OK') {
          if (cb) cb(txt);else if (cbErr) cbErr(txt);
        }
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "prjCreatePDF2",
    value: function prjCreatePDF2(prjId, catalog) {
      var customer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var options = arguments.length > 4 ? arguments[4] : undefined;
      var validto = arguments.length > 5 ? arguments[5] : undefined;
      var cb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        Catalogo: catalog,
        customer: customer,
        name: '',
        options: options,
        validto: validto
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPrjCreatePDF2', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "prjVersionCreate",
    value: function prjVersionCreate(prjId) {
      var versionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        name: versionName
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPrjVersionCreate', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "prjPdfList",
    value: function prjPdfList(prjId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPrjPdfList', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "infoPrj",
    value: function infoPrj(prjId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jInfoPrj', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "commentGet",
    value: function commentGet(prjId, all) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        all: all
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jCommentGet', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "comment",
    value: function comment(prjId, _comment, status) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        comment: _comment,
        status: ''
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jComment', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "commentDelete",
    value: function commentDelete(prjId, commentId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        commentid: commentId
      };
      _NextApiClient.NextApiClient.comg(this.service, 'CommentDelete', params, function (msg) {
        if (cb) cb(msg);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "recomputePrices",
    value: function recomputePrices(jsonPrj) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(jsonPrj)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jRecomputePrices', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cb(cbErr);
      });
    }
  }, {
    key: "linkedFiles",
    value: function linkedFiles(prjId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jLinkedFiles', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "linkedFileDelete",
    value: function linkedFileDelete(prjId, fileName) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        file: fileName
      };
      _NextApiClient.NextApiClient.comg(this.service, 'LinkedFileDelete', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "setstatus",
    value: function setstatus(prjId, status, toShop, toUser, extraData) {
      var cb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (j) {
        console.error(j);
      };
      if (!extraData) {
        _NextApiClient.NextApiClient.comg(this.service, 'jSetstatus', {
          id: prjId,
          status: status,
          toshop: toShop,
          touser: toUser
        }, function (json) {
          if (cb) cb(json);
        }, function (err) {
          if (cbErr) cbErr(err);
        });
      } else {
        _NextApiClient.NextApiClient.comg(this.service, 'jSetstatus2', {
          id: prjId,
          status: status,
          toshop: toShop,
          touser: toUser,
          extraData: (0, _stringify["default"])(extraData)
        }, function (json) {
          if (cb) cb(json);
        }, function (err) {
          if (cbErr) cbErr(err);
        });
      }
    }
  }, {
    key: "notifications",
    value: function notifications() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.comg(this.service, 'jNotifications', {}, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteNotifications",
    value: function deleteNotifications(rowId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        rowid: rowId
      };
      if (rowId !== null && rowId !== undefined) {
        _NextApiClient.NextApiClient.comg(this.service, 'jDeleteNotification', params, function (json) {
          if (cb) cb(json);
        }, function (err) {
          if (cbErr) cbErr(err);
        });
      } else if (cbErr) cbErr(new Error('Missing row id'));
    }
  }, {
    key: "prjVersionRestore",
    value: function prjVersionRestore(prjId, versionName) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        name: versionName
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPrjVersionRestore', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "prjVersionDelete",
    value: function prjVersionDelete(prjId, versionName) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        id: prjId,
        version: versionName
      };
      _NextApiClient.NextApiClient.com(this.service, 'jPrjVersionDelete', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "guestAdd",
    value: function guestAdd(guestData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(guestData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGuestAdd', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "guestChange",
    value: function guestChange(guestData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(guestData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGuestChange', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "guestCheck",
    value: function guestCheck(guestData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(guestData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGuestCheck2', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "anonymizeCustomer",
    value: function anonymizeCustomer(customerAddress) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        customer: customerAddress
      };
      _NextApiClient.NextApiClient.com(this.service, 'AnonymizeCustomer', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }]);
  return ProjectsAPI;
}();
exports.ProjectsAPI = ProjectsAPI;
ProjectsAPI.service = 'projects';
//# sourceMappingURL=ProjectsAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/ProjectsAPI.js
// module id = 1231
// module chunks = 142